import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from '../../firebase.config';

const updateProductStock = async (cartItems) => {
    try {
        for (const item of cartItems) {
            const productRef = doc(db, "products", item.id);
            const productSnap = await getDoc(productRef);

            if (!productSnap.exists()) {
                console.warn(`Product with ID ${item.id} not found.`);
                continue;
            }

            const productData = productSnap.data();

            // ✅ CASE 1: Product has variations
            if (productData.variations && productData.variations.length > 0 && item.selectedVariation) {
                const updatedVariations = productData.variations.map(variation => {
                    if (variation.variationName === item.selectedVariation) {
                        // Find the size inside variation.sizes array
                        const updatedSizes = variation.sizes.map(sizeObj => {
                            if (sizeObj.size === item.selectedSize) {
                                if (sizeObj.quantity < item.quantity) {
                                    throw new Error(`Insufficient stock for ${item.selectedSize} in variation ${variation.variationName}`);
                                }
                                return { ...sizeObj, quantity: sizeObj.quantity - item.quantity };
                            }
                            return sizeObj;
                        });
                        return { ...variation, sizes: updatedSizes };
                    }
                    return variation;
                });

                await updateDoc(productRef, { variations: updatedVariations });

            } else {
                // ✅ CASE 2: No variations → update main product sizes (map)
                if (!productData.sizes || !item.selectedSize) {
                    console.warn(`Sizes or selected size missing for product ${item.id}`);
                    continue;
                }

                const updatedSizes = { ...productData.sizes };
                const sizeEntry = updatedSizes[item.selectedSize];

                if (!sizeEntry) {
                    console.warn(`Size ${item.selectedSize} not found in product ${item.id}`);
                    continue;
                }

                if (sizeEntry.quantity < item.quantity) {
                    throw new Error(`Insufficient stock for ${item.selectedSize} in product ${item.id}`);
                }

                sizeEntry.quantity -= item.quantity;

                await updateDoc(productRef, { sizes: updatedSizes });
            }
        }
    } catch (error) {
        console.error("Error updating product stock:", error);
        throw new Error("Failed to update stock");
    }
};

export default updateProductStock;
